import {LightningIcon} from '@components/common';
import {SPEED_PLAY_COLOR, SPEED_SOLVE_COLOR} from '@utils';
import {Attempts} from '@types';

interface StatusIconProps {
    effectiveAttempts?: Attempts;
    hideCheckMarks: boolean;
}

function StatusIcon({effectiveAttempts, hideCheckMarks}: StatusIconProps) {
    if (!effectiveAttempts) return null;
    const {
        solved = 0,
        speedSolved = 0,
        speedPlay = 0,
        tries = 0,
    } = effectiveAttempts;

    if (tries === 0 || hideCheckMarks) return null;

    const isSolved = solved > 0;

    const renderIcon = () => {
        if (!isSolved) return <i className="fa-solid fa-circle-xmark" />;

        if (speedSolved > 0) {
            return (
                <LightningIcon
                    className="inline-block"
                    color={SPEED_SOLVE_COLOR}
                />
            );
        }

        if (speedPlay > 0) {
            return (
                <LightningIcon
                    className="inline-block"
                    color={SPEED_PLAY_COLOR}
                />
            );
        }

        return <i className="fa-solid fa-circle-check" />;
    };

    return (
        <span
            className={[
                'btn',
                'pe-none',
                'shrink-0',
                'border-0',
                'px-0',
                'sm:px-1',
                isSolved ? 'btn-outline-success' : 'btn-outline-danger',
            ].join(' ')}>
            {renderIcon()}
        </span>
    );
}

export default StatusIcon;
